import {createStyles, Theme} from "@material-ui/core";

export const AIStyle = (theme: Theme) => createStyles({
  slide : {
    minWidth: '100%',
    minHeight: '100%',
    maxWidth: '100%',
    scrollSnapAlign: 'start',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title : {
    fontSize: '28px',
    margin: '30px',
    textAlign: 'center',
    fontWeight: 700,
  }, 
  text : {
    fontSize: '20px',
    margin: '0px 30px',
    textAlign: 'center',
    fontWeight: 400,
  },
  buttonContainedLarge :{
    
  }
});




// WEBPACK FOOTER //
// ./src/components/calendar2/fab/ai.style.ts